import * as OBJECTACCESSRIGHTS from './objectAccessRights.constants';
import { ObjectAccessRights } from '../../models';

/** LOAD */
export function loadObjectAccessRights() {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_LOAD };
}

export function loadObjectAccessRightsSuccess(data: ObjectAccessRights[]) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_LOAD_SUCCESS, payload: data };
}

export function loadObjectAccessRightsError(error: any) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addObjectAccessRights(targetObjectAccessRights: ObjectAccessRights[]) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_ADD, payload: targetObjectAccessRights };
}

export function addObjectAccessRightsSuccess(targetObjectAccessRights: ObjectAccessRights[]) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_ADD_SUCCESS, payload: targetObjectAccessRights };
}

export function addObjectAccessRightsError(error: any) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateObjectAccessRights(targetObjectAccessRights: ObjectAccessRights[]) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_UPDATE, payload: targetObjectAccessRights };
}

export function updateObjectAccessRightsSuccess(targetObjectAccessRights: ObjectAccessRights[]) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_UPDATE_SUCCESS, payload: targetObjectAccessRights };
}

export function updateObjectAccessRightsError(error: any) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteObjectAccessRights(guids: string[]) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_DELETE, payload: guids };
}

export function deleteObjectAccessRightsSuccess(ObjectAccessRights: ObjectAccessRights[]) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_DELETE_SUCCESS, payload: ObjectAccessRights };
}

export function deleteObjectAccessRightsError(error: any) {
    return { type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_DELETE_ERROR, payload: error };
}